var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00306E",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0001 41.8334C49.2767 41.8334 47.6817 42.4384 46.4167 43.4467C44.7301 44.785 43.6667 46.8567 43.6667 49.1667C43.6667 50.5417 44.0517 51.8434 44.7301 52.9434C45.9951 55.07 48.3234 56.5 51.0001 56.5C52.8518 56.5 54.5384 55.8217 55.8218 54.6667C56.3901 54.19 56.8851 53.6034 57.2701 52.9434C57.9484 51.8434 58.3334 50.5417 58.3334 49.1667C58.3334 45.115 55.0518 41.8334 51.0001 41.8334ZM54.7951 48.3784L50.8901 51.99C50.6334 52.2283 50.2851 52.3567 49.9551 52.3567C49.6067 52.3567 49.2584 52.2284 48.9834 51.9534L47.1684 50.1384C46.6368 49.6068 46.6368 48.7267 47.1684 48.195C47.7001 47.6633 48.5801 47.6633 49.1118 48.195L49.9918 49.0751L52.9251 46.3617C53.4751 45.8483 54.3551 45.8851 54.8684 46.4351C55.3817 46.9851 55.3451 47.8467 54.7951 48.3784Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.6649 57.4166C56.6649 57.93 56.2616 58.3333 55.7483 58.3333H24.2516C23.7383 58.3333 23.335 57.93 23.335 57.4166C23.335 49.8266 30.815 43.6666 40 43.6666C41.8883 43.6666 43.7216 43.9232 45.4083 44.4182C44.3266 45.7016 43.6666 47.37 43.6666 49.1666C43.6666 50.5416 44.0516 51.8433 44.7299 52.9433C45.0966 53.5666 45.5733 54.1349 46.1233 54.6116C47.4066 55.7849 49.1116 56.5 51 56.5C53.0533 56.5 54.905 55.6566 56.225 54.2999C56.5183 55.2899 56.6649 56.335 56.6649 57.4166Z",
    fill: "#3270FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 40C45.0625 40 49.1666 35.8959 49.1666 30.8333C49.1666 25.7707 45.0625 21.6666 39.9999 21.6666C34.9373 21.6666 30.8333 25.7707 30.8333 30.8333C30.8333 35.8959 34.9373 40 39.9999 40Z",
    fill: "#3270FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3719e1fce3b470754d7cfa2e8386d547.svg";
export { ForwardRef as ReactComponent };